import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api.js';
import { STALE } from '@/lib/query-cache.js';
import type { JiraProject } from '@shared/types.js';

export function useProjects() {
  return useQuery({
    queryKey: ['projects'],
    queryFn: () => api.get<JiraProject[]>('/api/projects').then((r) => r.data),
    staleTime: STALE.PROJECTS,  // 10 min — follows Jira permission changes
  });
}

export function useProject(key: string) {
  return useQuery({
    queryKey: ['project', key],
    queryFn: () => api.get<JiraProject>(`/api/projects/${key}`).then((r) => r.data),
    enabled: !!key,
    staleTime: STALE.PROJECTS,
  });
}
